import Permissions from '../../models/Permissions'
const Index = () => import(/* webpackChunkName: "adduser" */ './Index.vue')
const Profile = () => import(/* webpackChunkName: "adduser" */ './Profile.vue')
const Password = () => import(/* webpackChunkName: "adduser" */ './Password.vue')

const permissions = [
  Permissions.ROOT,
  Permissions.ADMINISTRADOR
]

const modify = {
  path: 'cuser',
  name: 'Modificar Usuário',
  component: Index,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: permissions
  }
}

const profile = {
  path: 'profile/:cpf/:cpfCnpj',
  name: 'Perfil',
  component: Profile,
  props: true,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: permissions
  }
}

const password = {
  path: 'cpassword/:cpf/:cpfCnpj',
  name: 'Mudar Senha',
  component: Password,
  props: true,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  modify,
  profile,
  password
}



// WEBPACK FOOTER //
// ./src/views/user/index.js